export default __webpack_public_path__ + "static/instaO-93f4274b7451c4250081e8cae8b1758a.png";